/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Who_Title_LeadInputs */

const en_services_who_title_lead = /** @type {(inputs: Services_Who_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who`)
};

const pl_services_who_title_lead = /** @type {(inputs: Services_Who_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kto`)
};

/**
* | output |
* | --- |
* | "Who" |
*
* @param {Services_Who_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const services_who_title_lead = /** @type {((inputs?: Services_Who_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Who_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_services_who_title_lead(inputs)
	return en_services_who_title_lead(inputs)
});